import React, { forwardRef } from "react";
import FormControl from "../../components/formControl";
import CustomDropdown from "../../components/presentationals/CustomDropdown";
import { Button } from "@material-ui/core";
import config from "../../utils/config";
import CommonTable from "../../components/commonTable";
import LoadingAutocomplete from "../../components/presentationals/LoadingAutocomplete";

const EdOrdersSummaryView = forwardRef(
  (
    {
      searchFields,
      setSearchFields,
      timestamp,
      partners,
      productTypes,
      onRunClick,
      headers,
      keyArray,
      colSpanArray,
      edOrdersSummary,
      partnerName,
    },
    ref
  ) => {
    return (
      <div className="container-fluid">
        <div className="whitebox mt-2 mb-1">
          <form autoComplete="off">
            {partnerName.toLowerCase() === "nhq" ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                <CustomDropdown
                  name={"Region"}
                  data={config.region}
                  changeHandler={(value) =>
                    setSearchFields((prev) => ({
                      ...prev,
                      region: value,
                      state:
                        config?.states?.[
                          config?.regionMaps?.[value?.toUpperCase()]
                        ]?.[0],
                    }))
                  }
                  value={searchFields?.region}
                />
              </FormControl>
            ) : null}
            {["nhq", "region head"].includes(partnerName.toLowerCase()) ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                <CustomDropdown
                  name={"State"}
                  data={
                    config?.states?.[
                      config?.regionMaps?.[searchFields?.region?.toUpperCase()]
                    ]
                  }
                  changeHandler={(value) =>
                    setSearchFields((prev) => ({
                      ...prev,
                      state: value,
                    }))
                  }
                  value={searchFields?.state}
                />
              </FormControl>
            ) : null}
            {["nhq", "region head", "state head"].includes(
              partnerName.toLowerCase()
            ) ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                {partners?.loading ? (
                  <LoadingAutocomplete
                    loading={partners?.loading}
                    label="State"
                  />
                ) : (
                  <CustomDropdown
                    loading={partners?.loading}
                    name={"Partner Name"}
                    data={partners?.data?.content}
                    changeHandler={(value) =>
                      setSearchFields((prev) => ({
                        ...prev,
                        partner: value,
                      }))
                    }
                    value={searchFields?.partner}
                    labelFieldName={"partnerName"}
                  />
                )}
              </FormControl>
            ) : null}
            <FormControl variant="outlined" type="form" styleName="formControl">
              <CustomDropdown
                loading={productTypes?.loading}
                name={"Select Product"}
                data={["ALL", ...(productTypes?.data?.content || [])]}
                changeHandler={(value) =>
                  setSearchFields((prev) => ({
                    ...prev,
                    productType: value,
                  }))
                }
                value={searchFields?.productType ?? ""}
              />
            </FormControl>
            <FormControl variant="outlined" type="form" styleName="formControl">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  onRunClick();
                }}
                variant="contained"
                color="default"
                // disabled
              >
                Run
              </Button>
            </FormControl>
          </form>
        </div>

        <h2
          className="pagetitle wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
        >
          ED Orders Summary Dashboard
        </h2>
        <CommonTable
          headers={headers}
          keyArray={keyArray}
          tableData={edOrdersSummary}
          colSpanArray={colSpanArray}
          timestamp={timestamp}
          ref={ref}
        />
      </div>
    );
  }
);

export default EdOrdersSummaryView;
